module.exports = __webpack_public_path__ + "static/media/kelbuild-ltd.25edb543.jpg";